import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  label: {
    fontFamily: "Cairo",
    fontWeight: 400,
    fontSize: "16px",
    color: "#2A3333",
  },
  textEnabledSelect: {
    background: "#FFF",
    width: "100%",
    marginTop: "8px",
  },
}));
